import React from "react";
import { Link } from "react-router-dom";

export function Button({ variant = "primary", as, to, className = "", children, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 px-7 py-3 text-sm font-semibold tracking-[0.02em] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-[#0F2C59] focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-[#0F2C59] text-white hover:bg-[#16447F]",
    secondary: "bg-transparent text-[#0F2C59] border border-[#0F2C59] hover:bg-[#0F2C59] hover:text-white",
    gold: "bg-[#B58A3E] text-white hover:bg-[#9A7635]",
    ghost: "bg-transparent text-[#0F2C59] hover:text-[#16447F] !px-0 !py-0",
    white: "bg-white text-[#0F2C59] hover:bg-slate-100",
    outlineWhite: "bg-transparent text-white border border-white/40 hover:bg-white hover:text-[#0F2C59]",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  const Tag = as || "button";
  return <Tag className={cls} {...props}>{children}</Tag>;
}

export function Overline({ children, className = "" }) {
  return <span className={`overline ${className}`}>{children}</span>;
}

export function Section({ children, className = "", ...props }) {
  return (
    <section className={`px-5 sm:px-8 ${className}`} {...props}>
      <div className="max-w-6xl mx-auto">{children}</div>
    </section>
  );
}

export function Divider({ brand = false, className = "" }) {
  return <div className={`h-px w-full ${brand ? "bg-[#BFDBFE]" : "bg-slate-200"} ${className}`} />;
}

export function BlueRule({ className = "" }) {
  return <div className={`h-[2px] w-12 bg-[#B58A3E] ${className}`} />;
}

export function GoldRule({ className = "" }) {
  return <div className={`gold-rule ${className}`} />;
}
